<template>
  <div
    :class="$style.toastContainer"
    role="status"
    aria-live="polite"
    aria-atomic="false"
  >
    <TransitionGroup name="toast">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        :class="[
          $style.toastItem,
          $style[`toast-${toast.type ?? 'info'}`],
          'type-body-medium-emphasized',
        ]"
        :role="
          toast.type === 'error' || toast.type === 'warning'
            ? 'alert'
            : undefined
        "
        @click="() => toastStore.remove(toast.id)"
      >
        {{ toast.message }}
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia'
  import { useToastStore } from '~/stores/toastStore'
  const toastStore = useToastStore()
  const { toasts } = storeToRefs(toastStore)
</script>
<style module>
  .toastContainer {
    display: flex;
    flex-direction: column;
    gap: var(--space-12);
    position: fixed;
    bottom: var(--space-16);
    right: 0;
    left: 0;
    z-index: 1001;
    cursor: pointer;
    margin: 0 auto;
    width: fit-content;
  }

  .toastItem {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--space-8) var(--space-16);
    border-radius: var(--radius-sm);
    box-shadow: var(--elevation-md);
    text-align: center;
    transition: all 0.3s ease-in-out;
  }

  .toast-success {
    background-color: var(--color-status-success);
    color: var(--color-text-on-brand);
  }

  .toast-error {
    background-color: var(--color-status-error);
    color: var(--color-text-on-brand);
  }

  .toast-warning {
    background-color: var(--color-status-warning);
    color: var(--color-text-primary);
  }

  .toast-info {
    background-color: var(--color-interactive-link);
    color: var(--color-text-on-brand);
  }
</style>

<style scoped>
  .toast-enter-active {
    transition: all 0.3s ease-out;
  }

  .toast-leave-active {
    transition: all 0.2s ease-in;
  }

  .toast-enter-from,
  .toast-leave-to {
    transform: translateY(1rem);
    opacity: 0;
  }

  .toast-enter-to,
  .toast-leave-from {
    transform: translateY(0);
    opacity: 1;
  }
</style>
